export const replaceURL = (url: string) => {
    if(url){
      window.history.replaceState(null, "", url);
    }
}